import {getButtonSlotArray} from '@/util/componentUtil';
import {getConditionSlotArray} from '@/util/componentCoreUtil';
export default {
  props: {
    rowConfig: {
      type: Object,
      default() {
        return {
          isHover: true,
          isCurrent: true
        };
      }
    },
    autoInitTableSetting: {
      type: Boolean,
      default: true
    },
    scrollY: {
      type: Object,
      default() {
        return {gt: 60};
      }
    },
    buttonConfig: {
      type: Object,
      default() {
        return {
          list: []
        };
      }
    },
    conditionConfig: {
      type: Object
    },
    mouseConfig: {
      type: Object,
      default() {
        return {area: true, extension: true};
      }
    },
    custom: {
      type: [Boolean, Object],
      default: true
    },
    editConfig: Object,
    pageFooterConfig: Object,
    excelConfig: Object,
    downloadApi: Function,
    columnSortable: {
      type: Boolean,
      default: false
    },
    drawerConfig: {
      type: Object,
      default() {
        return {
          show: true,
          openText: '展开',
          closeText: '收起',
          limit: 4
        };
      }
    },
    sortConfig: Object,
    drawerFlag: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    handlePageFooterDblclick(e) {
      this.$emit('page-footer-dblclick', e);
    },
    validate() {
      const xCondition = this.$refs.xCondition;
      if (!xCondition) {
        throw new NonsenseError('xCondition is null');
      }
      return xCondition.validate();
    },
    getFormInstance() {
      return this.$refs.xCondition.getFormInstance();
    },
    handleCellClick(args) {
      if (this.realEditConfig.trigger === 'click') {
        const column = args.column;
        // 判断这一列是否可以编辑，如果不可以就激活行，可以就激活单元格，这样设置是为了实现点击单元格是让输入框获取焦点
        if ((!column.editRender || column.editRender.enabled === false) && this.realEditConfig.mode === 'row') {
          this.$refs.xTable.setActiveRow(args.row);
        } else {
          this.$refs.xTable.setActiveCell(args.row, column);
        }
      }
      this.$emit('cell-click', args);
    },
    handleTabClick(tabPane) {
      this.$emit('tab-click', tabPane);
    }
  },
  computed: {
    realFilterConfig() {
      const defaultConfig = {remote: true};
      if (this.filterConfig) {
        Object.assign(defaultConfig, this.filterConfig);
      }
      return defaultConfig;
    },
    realSortConfig() {
      const defaultConfig = {remote: true, multiple: true};
      if (this.sortConfig) {
        Object.assign(defaultConfig, this.sortConfig);
      }
      return defaultConfig;
    },
    realDrawerConfig() {
      const defaultConfig = { show: true, openText: '展开', closeText: '收起', limit: 4 };
      if (!this.drawerConfig) {
        return defaultConfig;
      }
      return Object.assign(defaultConfig, this.drawerConfig);
    },
    realEditConfig() {
      const defaultEditConfig = {trigger: 'dbclick', mode: 'row', showStatus: false, showIcon: false};
      if (!this.editConfig) {
        return defaultEditConfig;
      }
      Object.assign(defaultEditConfig, this.editConfig);
      return defaultEditConfig;
    },
    buttonSlotArray() {
      return getButtonSlotArray(this.buttonConfig);
    },
    conditionSlotArray() {
      return getConditionSlotArray(this.conditionConfig);
    }
  },
  created() {
    this.timeoutIdArr = [];
  },
  beforeDestroy() {
    for (const item of this.timeoutIdArr) {
      clearTimeout(item);
    }
  }
};
